import React, { useState } from "react";
import {
  Button,
} from '@lockerpm/design';

import { } from 'react-redux';
import { useTranslation } from "react-i18next";

import ExportConfirmModal from "./ExportConfirm";
import ExportFormData from "./ExportFormData";

import {
} from '../../../../../components'

import {
} from '../../../../../utils/common'

import {
  ExportOutlined
} from "@ant-design/icons";

const Export = (props) => {
  const {
    className = '',
  } = props;
  const { t } = useTranslation();
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [formVisible, setFormVisible] = useState(false);

  return (
    <div className={className}>
      <div className="flex justify-between">
        <p className="font-semibold text-xl">
          {t('import_export.export')}
        </p>
        <Button
          type='primary'
          icon={<ExportOutlined />}
          onClick={() => setConfirmVisible(true)}
        >
          {t('button.export')}
        </Button>
      </div>
      <p className="mt-1">
        {t('import_export.export_description')}
      </p>
      <ExportConfirmModal
        visible={confirmVisible}
        onConfirm={() => setFormVisible(true)}
        onClose={() => setConfirmVisible(false)}
      />
      <ExportFormData
        visible={formVisible}
        onClose={() => setFormVisible(false)}
      />
    </div>
  );
}

export default Export;
